/**
 * @name CHOOSE_PARAMETERS
 * @constant
 * @description Track when displayed parameters change
 */
export const CHOOSE_PARAMETERS = 'pstChooseParameters';

/**
 * @name CLOSE_PARAMETERS
 * @constant
 * @description Track when displayed parameters modal is closed
 */
export const CLOSE_PARAMETERS = 'pstCloseParameters';

/**
 * @name DOWNLOAD_EXCEL
 * @constant
 * @description Track when a table is downloaded to excel
 */
export const DOWNLOAD_EXCEL = 'pstDownload';

/**
 * @name DOWNLOAD_DATASHEET
 * @constant
 * @description Track when a datasheet is downloaded
 */
export const DOWNLOAD_DATASHEET = 'downloadDataSheet';

/**
 * @name DOWNLOAD_DATASHEET_RIGHT_CLICK
 * @constant
 * @description Track when a datasheet is downloaded via right click
 */
export const DOWNLOAD_DATASHEET_RIGHT_CLICK = 'rightClickDownloadDataSheet';

/**
 * @name FILTER
 * @constant
 * @description Track when a column is filtered
 */
export const FILTER = 'pstFilterColumn';

/**
 * This is _NOT_ a direct call rule. Do not attempt to execute this in DTM
 * @name CHOOSE_PARAMETERS
 * @constant
 * @description Name of the window variable that stores the last edited parameter
 */
export const LAST_FILTERED_PARAM = 'lastFilteredParam';

/**
 * @name PERSONALIZATION_ENGINEER
 * @constant
 * @description Add engineer personalization
 */
export const PERSONALIZATION_ENGINEER = 'engineerPersonalizationPSTLinkClick';

/**
 * @name PRINT
 * @deprecated
 * @constant
 * @description Track when the table is printed
 */
export const PRINT = 'print';

/**
 * @name PRODUCT_VIEW
 * @deprecated
 * @constant
 * @description Track when a product is viewed
 */
export const PRODUCT_VIEW = 'productView';

/**
 * @name RESET_TABLE
 * @constant
 * @description Track when the table is reset
 */
export const RESET_TABLE = 'pstResetTable';

/**
 * @name SHARE
 * @constant
 * @description Track a table is shared
 */
export const SHARE = 'share';

/**
 * @name SORT_COLUMN
 * @constant
 * @description Track sorting column
 */
export const SORT_COLUMN = 'pstSortColumn';

/**
 * @name SORT_NEWEST
 * @constant
 * @description Track when table is sorted by newest parts
 */
export const SORT_NEWEST = 'pstSortNewest';

/**
 * @name TOGGLE_DISPLAY
 * @constant
 * @description Track toggle size of parameters (min/max)
 */
export const TOGGLE_DISPLAY = 'pstToggleFilterDisplay';